// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomSortBy_wrapper__Yje97","group":"CustomSortBy_group__OL6dc","radio":"CustomSortBy_radio__soxuT"};